const faqs = document.querySelectorAll(".faq-list h4");

faqs.forEach(faq => {
  faq.addEventListener("click", (event) => {
    const faqAnswer = (event.target as HTMLElement | null)?.parentElement?.querySelector(".faq-answer");
    if (faqAnswer) faqAnswer.classList.toggle("visible");
  });
});